let store

export function setStore (x) {
  store = x
}

export default function Y () {
  // const config = store ? store.getState().locales.locales : {}
  const config = store.getState().locales.locales
  let str = ''
  let args = arguments
  if (args.length === 1) {
    args[0].forEach(function (part, i) {
      const arg = args[i + 1]
      str += part
      if (typeof arg !== 'undefined') {
        str += '%s'
      }
    })
  } else {
    str = args[1]
  }
  const value = config[str] || str
  let count = 1
  return value.replace(/%s/g, x => args[count++])
}



// WEBPACK FOOTER //
// ./src/y18n.js